import React from 'react'
import { Parallax } from 'react-parallax'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { about } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={about} w="100%" alt="Todak Todak About" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView m="0 auto">
          <CFView
            column
            center
            h="475px"
            w="100%"
            maxWidth="1400px"
            image={`url(${about}) top/ cover no-repeat`}
            style={{ backgroundAttachment: 'fixed' }}
          ></CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
